import LblLayout from '@/layouts/lbl'

export default [
  {
    name: 'lbl',
    path: '/',
    redirect: '/download',
    component: LblLayout,
    children: [
      {
        name: 'download',
        path: '/download',
        component: () => import('_lbl/download'),
        meta: {
          title: '立林智慧生活APP'
        }
      },
      {
        name: 'vstore',
        path: '/vstore/:type',
        component: () => import('_lbl/vstore'),
        meta: {
          title: '立林智慧生活APP'
        }
      },
      {
        name: 'votingList',
        path: '/votingList/:neighNo',
        component: () => import('_lbl/votingAndQuestion'),
        meta: {
          title: '立林智慧生活APP-投票列表',
          type: 1
        }
      },
      {
        name: 'votingDetail',
        path: '/voting/:neighNo/:id',
        component: () => import('_lbl/votingAndQuestion/VotingDetail'),
        meta: {
          title: '立林智慧生活APP-投票详情'
        }
      },
      {
        name: 'questionList',
        path: '/questionList/:neighNo',
        component: () => import('_lbl/votingAndQuestion'),
        meta: {
          title: '立林智慧生活APP-问卷列表',
          type: 2
        }
      },
      {
        name: 'questionDetail',
        path: '/question/:neighNo/:id',
        component: () => import('_lbl/votingAndQuestion/QuestionDetail'),
        meta: {
          title: '立林智慧生活APP-问卷详情'
        }
      },
      {
        name: 'lblMessage',
        path: '/message/:id',
        component: () => import('_lbl/message'),
        meta: {
          title: '立林智慧生活APP-消息详情'
        }
      },
      {
        name: 'lblMarketingDetail',
        path: '/marketing/:neighNo/:id',
        component: () => import('_lbl/details'),
        meta: {
          title: '立林智慧生活APP-地产营销详情',
          type: 0
        }
      },
      {
        name: 'lblAnnounceDetail',
        path: '/announce/:neighNo/:id',
        component: () => import('_lbl/details'),
        meta: {
          title: '立林智慧生活APP-社区公告详情',
          type: 1
        }
      },
      {
        name: 'lblguideDetail',
        path: '/guide/:neighNo/:id',
        component: () => import('_lbl/details'),
        meta: {
          title: '立林智慧生活APP-社区指南详情',
          type: 2
        }
      },
      {
        name: 'lblArticleManageDetail',
        path: '/articleManage/:id',
        component: () => import('_lbl/details'),
        meta: {
          title: '立林智慧生活APP-文章详情',
          type: 3
        }
      },
      {
        name: 'lblHelp',
        path: '/help',
        component: () => import('_lbl/help'),
        meta: {
          title: '立林智慧生活APP-帮助中心列表'
        }
      },
      {
        name: 'lblHelpSearch',
        path: '/help/search',
        component: () => import('_lbl/help/Search'),
        meta: {
          title: '立林智慧生活APP-帮助中心搜索'
        }
      },
      {
        name: 'lblHelpClass',
        path: '/help/class/:categoryId',
        component: () => import('_lbl/help/Class'),
        meta: {
          title: '立林智慧生活APP-帮助中心分类列表'
        }
      },
      {
        name: 'lblHelpDetail',
        path: '/help/detail/:problemId',
        component: () => import('_lbl/help/Detail'),
        meta: {
          title: '立林智慧生活APP-帮助中心详情'
        }
      },
      {
        name: 'lblNoticeOfComplaint',
        path: '/noticeOfComplaint',
        component: () => import('_lbl/noticeOfComplaint'),
        meta: {
          title: '立林智慧生活APP-投诉须知'
        }
      },
      {
        name: 'lblDynamicDetail',
        path: '/dynamicDetail/:dynamicId',
        component: () => import('_lbl/dynamicDetail'),
        meta: {
          title: '立林智慧生活APP-动态详情'
        }
      },
      {
        name: 'lblCircleDetail',
        path: '/circleDetail/:circleId',
        component: () => import('_lbl/circleDetail'),
        meta: {
          title: '立林智慧生活APP-圈子详情'
        }
      },
      {
        name: 'lblNoticeOfCircle',
        path: '/noticeOfCircle',
        component: () => import('_lbl/noticeOfCircle'),
        meta: {
          title: '立林智慧生活APP-创圈须知'
        }
      },
      {
        name: 'lblimouplay',
        path: '/imou/play',
        component: () => import('_lbl/imou/play'),
        meta: {
          title: '立林智慧生活APP-imou'
        }
      }
    ]
  }
]
